import NodeRenderer from './NodeRenderer.js'
import TerritoryRenderer from './TerritoryRenderer.js'
import TerritoryFieldRenderer from './TerritoryFieldRenderer.js'

export default class Renderer {
  init(root) {
    this.root = root
    this.root.innerHTML = ''

    this.canvas = document.createElement('canvas')
    this.canvas.className = 'map-canvas'
    this.ctx = this.canvas.getContext('2d')
    this.nodeRenderer = new NodeRenderer(this.ctx)
    this.territoryRenderer = new TerritoryRenderer(this.ctx)
    this.territoryFieldRenderer = new TerritoryFieldRenderer(this.ctx)

    this.root.appendChild(this.canvas)

    this.handleResize = () => this.resize()
    window.addEventListener('resize', this.handleResize)
    this.resize()
   }

  setCamera(camera) {
    this.camera = camera
    this.camera.setViewport(this.getViewport())
   }

  getCanvas() {
    return this.canvas
   }

  getViewport() {
    return {
      width: this.canvas.clientWidth || window.innerWidth,
      height: this.canvas.clientHeight || window.innerHeight
     }
   }

  resize() {
    const width = window.innerWidth
    const height = window.innerHeight
    const ratio = window.devicePixelRatio || 1

    this.canvas.width = width * ratio
    this.canvas.height = height * ratio
    this.canvas.style.width = `${width}px`
    this.canvas.style.height = `${height}px`
    this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0)

    if (this.camera) {
      this.camera.setViewport({ width, height })
     }
   }

  render({ vibes, links, territories, clusterAssignments, atmosphere, state, time }) {
    const viewport = this.getViewport()

    this.ctx.clearRect(0, 0, viewport.width, viewport.height)
    this.drawBackdrop(viewport, atmosphere, time)
    this.territoryFieldRenderer.draw({ territories, camera: this.camera, state, atmosphere, viewport, time })
    this.nodeRenderer.draw({ vibes, links, camera: this.camera, state, atmosphere, time, clusterAssignments, territories })
    this.territoryRenderer.drawLabels({ territories, camera: this.camera, state, viewport, time })
   }

  drawBackdrop(viewport, atmosphere, time) {
    const baseGradient = this.ctx.createRadialGradient(
      viewport.width * (0.45 + Math.sin(time * 0.05) * 0.03),
      viewport.height * 0.4,
      viewport.width * 0.08,
      viewport.width * 0.5,
      viewport.height * 0.5,
      viewport.width * 0.85
     )

    baseGradient.addColorStop(0, 'rgba(20, 28, 54, 1)')
    baseGradient.addColorStop(0.5, 'rgba(9, 14, 30, 1)')
    baseGradient.addColorStop(1, 'rgba(2, 5, 12, 1)')

    this.ctx.fillStyle = baseGradient
    this.ctx.fillRect(0, 0, viewport.width, viewport.height)

    this.ctx.fillStyle = `rgba(96, 122, 255, ${0.04 + atmosphere.glow * 0.04})`
    this.ctx.fillRect(0, 0, viewport.width, viewport.height)
   }
}